import axios from "axios";

//  const API_BASE_URL = "https://api.learn2ern.com/api/";
//////////////////////
//  const API_BASE_URL = "https://learn2earn-alpha.vercel.app/";
//////////////////////
//  const API_BASE_URL = "http://localhost:8001/api/";
// const API_BASE_URL ="https://api.learn2earn24x7.com/api/";
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === "production" ? "https://api.adhyayi.com/api/" : "http://localhost:8001/api/");
// const API_BASE_URL ="https://api.adhyayi.com/api/";
// const API_BASE_URL ="https://learn2earn-backend-test.vercel.app/api/";
// const API_BASE_URL ="https://learn2earn-backend-staging.onrender.com/api/";


// const DEFAULT_API_BASE_URL =
//   process.env.NODE_ENV === "development"
//     ? "http://localhost:8001/api/"
//     : "https://learn2earn-backend-staging.onrender.com/api/";

// const API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;
// const API_BASE_URL = "http://localhost:8001/api/";
// const API_BASE_URL = "https://learn2earn-backend-staging.onrender.com/api/";
const API_BASE_URL = "https://api.adhyayi.com/api";
const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    // console.log(token);
    // console.log("token");
    if (token) {
      config.headers.Authorization = token.startsWith("Bearer ")
        ? token
        : `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);

export default instance;
